import { IconProps } from "./HomeIcon";

const SettingIcon = ({ color = "#18988B" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M13.5 9V7H16.5V3H18.5V7H21.5V9H13.5ZM16.5 21V11H18.5V21H16.5ZM6.5 21V17H3.5V15H11.5V17H8.5V21H6.5ZM6.5 13V3H8.5V13H6.5Z"
        fill={color}
      />
    </svg>
  );
};

export default SettingIcon;
